import { useInjectReducer } from "@app/store";
import { useLoadPublicSchemeDetailsQuery } from "@features/publicPage/schemeDetails/api";
import schemeDetailsSlice from "@features/publicPage/schemeDetails/slice";
import { APP_NAME } from "@utils/constants";
import { returnImgSrc } from "@utils/helpers";
import moment from "moment";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import SchemeLoading from "./components/Loading";
import PublicProductCard from "./components/ProductCard";
import PublicSchemePriceDetails from "./components/SchemePriceDetails";
import { RiCloseFill, RiMegaphoneLine } from "react-icons/ri";
import { Link } from "react-router-dom";

const PublicSchemeDetails = () => {
  useInjectReducer("schemeDetails", schemeDetailsSlice);

  const { id: scheme_id } = useParams();

  // load single scheme details
  const { data, isLoading: loading } = useLoadPublicSchemeDetailsQuery(
    scheme_id,
    { skip: !scheme_id, refetchOnMountOrArgChange: true }
  );

  const scheme = data?.data || null;

  if (loading) {
    return <SchemeLoading />;
  }

  if (scheme) {
    return (
      <>
        <Helmet>
          <title>{`${scheme?.name} | ${APP_NAME}`}</title>
        </Helmet>
        {loading ? (
          <SchemeLoading />
        ) : (
          <div className='container mx-auto text-sm mb-10'>
            <div className='mt-2 mb-4'>
              {scheme?.image?.length > 1 ? (
                <Slider
                  {...{
                    ...sliderSettings,
                  }}
                >
                  {scheme.image?.map((image) => (
                    <img
                      src={returnImgSrc(image)}
                      alt='Carousel-Image'
                      className='w-full'
                      key={image?._id}
                    />
                  ))}
                </Slider>
              ) : (
                <img
                  src={returnImgSrc(scheme?.image?.[0])}
                  alt='Carousel-Image'
                  className='w-full'
                  key={scheme?.image?.[0]?._id}
                />
              )}
            </div>
            <h2 className='text-2xl font-medium'>{scheme?.name}</h2>
            <div className='mb-1 flex justify-between items-center'>
              <div>
                <span>{moment(scheme?.start_date).format("ll")}</span> -{" "}
                <span>{moment(scheme?.end_date).format("ll")}</span>
              </div>
              {/* <div>
              {scheme?.actual_price - scheme?.offer_price > 0 ? (
                <div className=''>
                  <span className='text-gray-600 line-through mr-1.5'>
                    {CURRENCY_SIGN} {commaNumber(scheme.actual_price)}
                  </span>
                  <span className='font-semibold text-2xl'>
                    {CURRENCY_SIGN} {commaNumber(scheme.offer_price)}
                  </span>
                </div>
              ) : (
                <div>
                  {CURRENCY_SIGN} {commaNumber(scheme.offer_price)}
                </div>
              )}
            </div> */}
            </div>
            <p
              dangerouslySetInnerHTML={{
                __html: scheme?.description,
              }}
              className='text-sm'
            />
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-2 mt-6'>
              <div className='col-span-2 md:col-span-1 lg:col-span-2'>
                <div className='text-primary font-semibold mb-1'>
                  Main Product
                </div>
                {scheme?.main_product && (
                  <PublicProductCard value={scheme?.main_product} />
                )}
              </div>{" "}
              <div className='col-span-2 md:col-span-1 lg:col-span-2'>
                <div className='text-primary font-semibold mb-1'>
                  Bundled Products
                </div>
                {scheme?.bundle_product?.length > 0 ? (
                  <>
                    {scheme.bundle_product.map((each) => (
                      <Fragment key={each._id}>
                        <PublicProductCard value={each.product_id} is_bundled />
                      </Fragment>
                    ))}
                  </>
                ) : (
                  <div className='text-gray-500'>
                    No bundled products in this scheme.
                  </div>
                )}
              </div>
              <div className='col-span-2 my-4'>
                {/* <div className='text-primary font-semibold mb-1'>
                Scheme & Product Price Details
              </div> */}
                <PublicSchemePriceDetails scheme={scheme} />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{`Scheme Not Found | ${APP_NAME}`}</title>
      </Helmet>
      <div className='my-32 flex justify-center items-center flex-col gap-4 font-semibold text-lg'>
        <RiCloseFill size='30' className='text-danger' />
        Scheme Not Available.
        <Link
          to='/'
          className='text-blue-500 hover:underline text-sm font-normal'
        >
          Go Home
        </Link>
      </div>
    </>
  );
};

export default PublicSchemeDetails;

const sliderSettings = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  // this is the speed of the slide chaning
  speed: 500,
  // this is the speed that the slider waits to change to next slide
  autoplaySpeed: 4000,
};
